export const WidthStyle = {property: 'WidthStyle', styleProperty: 'width'}
